module.exports = __webpack_public_path__ + "img/bg62.c5d5bc30.png";